var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"publication-list"}},[_c('h1',[_vm._v("Publication")]),_c('div',{staticClass:"publication-container"},[_c('el-timeline',_vm._l((_vm.published),function(i,index){return _c('div',{key:i.id},[_c('PublicationItem',{attrs:{"item":i,"index":index,"itemStatus":_vm.itemStatus,"switchStatus":_vm.switchStatus}})],1)}),0)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }